import classNames from "classnames"
import "./Footer.scss"
import { Link, useLocation } from "react-router-dom"
import { MenuOption } from "../../utils/types"
import { getMenuOptions, MENU_OPTION_IDS } from "../../utils"
import { useTextStorage } from "../../hooks"
import InstagramIcon from "../../assets/images/instagram-icon.svg?react"
import FacebookIcon from "../../assets/images/facebook-icon.svg?react"
import LinkedInIcon from "../../assets/images/linkedin-icon.svg?react"

export const Footer: React.FC = () => {
  const { ts } = useTextStorage()
  const { pathname } = useLocation()
  const menuOptions = getMenuOptions(MENU_OPTION_IDS, pathname, ts)

  const footerColumnOne = [menuOptions[0], menuOptions[1], menuOptions[2]]
  const footerColumnTwo = [menuOptions[3], menuOptions[4], menuOptions[5]]
  return (
    <div className="footer-outer-box">
      <div className="footer-link-column-outer-box">
        <div className="footer-link-column-inner-box">
          {footerColumnOne.map((menuOption) => (
            <FooterLink key={menuOption.id} menuOption={menuOption} />
          ))}
        </div>
      </div>
      <div className="footer-link-column-outer-box bordered">
        <div className="footer-link-column-inner-box">
          {footerColumnTwo.map((menuOption) => (
            <FooterLink key={menuOption.id} menuOption={menuOption} />
          ))}
        </div>
      </div>
      <div className="footer-info-column-outer-box">
        <div className="footer-info-column-inner-box">
          <span>{`${ts.footerInfo.phoneNumberLabel}: ${ts.footerInfo.phoneNumber}`}</span>
          <span>{`${ts.footerInfo.emailLabel}: ${ts.footerInfo.email}`}</span>
          <div className="footer-info-column--icons">
            <Link
              to={ts.footerInfo.facebookLink}
              className="footer-info-column--icon"
            >
              <FacebookIcon />
            </Link>
            <Link
              to={ts.footerInfo.instagramLink}
              className="footer-info-column--icon"
            >
              <InstagramIcon />
            </Link>
            <Link
              to={ts.footerInfo.linkedinLink}
              className="footer-info-column--icon"
            >
              <LinkedInIcon />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

const FooterLink: React.FC<{
  menuOption: MenuOption
}> = ({ menuOption }) => {
  const { displayText, linksTo, isActive } = menuOption
  if (!displayText || !linksTo) {
    return null
  }
  return (
    <div className={classNames("footer-link", { active: isActive })}>
      <Link to={linksTo}>{displayText.toUpperCase()}</Link>
    </div>
  )
}
